module.exports = __webpack_public_path__ + "fonts/dk_plakkaat-webfont.39c945f25e05552024bfc396f0d375f2.woff2";